<template>
    <div @click="buttonClicked" ref="button" class="button__wrapper"
         :style="{
            margin: finalMargin,
            padding: finalPadding,
        }">
            <div v-show="finalType == 'strong' || finalType == 'warning'">
                <span v-if="buttonIcon && buttonIcon.name" class="button__icon">
                    <Icon :name="buttonIcon.name" :width="16" :color="buttonIcon.color" :dark_color="buttonIcon.dark_color" :active="buttonIcon.active"></Icon>
                </span>
                {{ text }}
            </div>
            <div v-show="finalType == 'progress'" >
                <span class="button__wrapper-bottom-text">{{text}}</span>
                <span ref="progress" class="button__process-bar">
                    <span ref="progress_text" class="button__process-text" style="padding: 0">
                        {{ text }}
                    </span>
                </span>
            </div>
            <div v-show="finalType == 'weak' || finalType == 'weaker' || finalType == 'white'">
                <span v-if="buttonIcon && buttonIcon.name" class="button__icon">
                    <Icon :name="buttonIcon.name" :width="16" :color="buttonIcon.color" :dark_color="buttonIcon.dark_color" :active="buttonIcon.active"></Icon>
                </span>
                {{ text }}
            </div>
            <div v-show="finalType == 'disable' || finalType == 'disabled'" >
                {{ text }}
            </div>
    </div>
</template>
<script>
    import Env from 'common/env.js';
    import ajaxcall from 'common/ajaxcall.js';
    import Icon from 'Icon/index.vue';
    import Mixin from '../WgUI/mixin.js';
    if(!Env.isCSR) {
        window.__normalButtonConfig = window.__normalButtonConfig || null;
        window.__isReqingButtonConfig = false;
        window.__reqButtonConfigCbks = {succ: [], fail: []};
    }
    function reqButtonConfig(succ, fail) {
        if ( window.__normalButtonConfig ) {
            succ(window.__normalButtonConfig);
            return;
        }
        window.__reqButtonConfigCbks.succ.push(succ);
        window.__reqButtonConfigCbks.fail.push(fail);
        if ( window.__isReqingButtonConfig ) {
            return;
        }
        window.__isReqingButtonConfig = true;
        ajaxcall('https://game.weixin.qq.com/cgi-bin/gamecenterwap/getgamecenterbuttonconfig', {
            method: 'POST',
        }, function(res) {
            window.__normalButtonConfig = res;
            window.__reqButtonConfigCbks.succ.forEach(function(cbk) {
                cbk(res)
            })
            window.__reqButtonConfigCbks.succ = []
        }, function(err) {
            window.__reqButtonConfigCbks.fail.forEach(function(cbk) {
                cbk(res)
            })
            window.__reqButtonConfigCbks.fail = []
        })
    }
    function copyObj(obj) {
        try {
            return JSON.parse(JSON.stringify(obj));
        } catch (e) {
            console.error(e);
            return {}
        }
    }
    function isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    }
    function mergeDeep(target, ...sources) {
        if (!sources.length) return target;
        const source = sources.shift();
        if (isObject(target) && isObject(source)) {
            for (const key in source) {
                if (isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }
        return mergeDeep(target, ...sources);
    }
    export default {
        mixins: [Mixin],
        name: 'NormalButton',
        props: {
            text: {
                type: String,
                default: '进入'
            },
            width: {
                type: String,
            },
            height: {
                type: String,
            },
            main: {
                type: Object,
                default() {
                    return {
                        // bgColor: '#F7F7F7', //'#FFC300',
                        // fontColor: '#4C4C4C', //'#FFFFFF',
                        // pressColor: '#E5E5E5', //'#E7AE02',
                        // bgColor: '#FFC300', //'#F7F7F7',
                        // fontColor: '#FFFFFF', //'#FFAF00',
                        // pressColor: '#E7AE02', //'#E5E5E5'
                    }
                }
            },
            sub: {
                type: Object,
                default() {
                    return {
                        // bgColor: '#FFC300', //'#F7F7F7',
                        // fontColor: '#FFFFFF', //'#FFAF00',
                        // pressColor: '#E7AE02', //'#E5E5E5'
                        // bgColor: '#F7F7F7', //'#FFC300',
                        // fontColor: '#4C4C4C', //'#FFFFFF',
                        // pressColor: '#E5E5E5', //'#E7AE02'
                    }
                }
            },
            disable: {
                type: Object,
                default() {
                    return {
                        // bgColor: '#F2F2F2',
                        // fontColor: '#C5C5C5',
                    }
                }
            },
            font: {
                type: Object,
                default() {
                    return {
                        fontSize: '16px',
                        fontFamily: '',
                        lineHeight: '28.8px',
                        // fontWeight: 'bold',
                    }
                }
            },
            border: {
                type: Object,
                default() {
                    return {
                        radius: '3px',
                    }
                }
            },
            type: {
                type: String,
                default: 'default', // default, strong, weak, progress, disable, white
            },
            // 1：大按钮
            btnStyle: {
                type: Number,
                default: 0
            },
            buttonIcon: {
                type: Object
            },
            active: Boolean, // 是否有点击态
            autoDownload: Boolean,
            canAutoDownload: Boolean,
            styleObject: {
                type: Object,
                default () {
                    return {
                    }
                }
            },
        throttleTime: Number
        },
        data() {
            return {
                // default
                renderConfig: {
                    width: '76px',
                    height: '32px',
                    main: {
                        bgColor: '#06AE56', //'#F7F7F7',
                        fontColor: '#FFFFFF', //'#FFAF00',
                        pressColor: '#06AE56', //'#E5E5E5'
                    },
                    sub: {
                        bgColor: '#F2F2F2', //'#FFC300',
                        fontColor: ' #06AE56', //'#FFFFFF',
                        pressColor: '#E5E5E5', //'#E7AE02'
                    },
                    disable: {
                        bgColor: '#F2F2F2',
                        fontColor: '#C5C5C5',
                    },
                    font: {
                        fontSize: '16px',
                        fontFamily: '',
                        lineHeight: '28.8px',
                        // fontWeight: 'bold',
                    },
                    border: {
                        radius: '3px',
                    },
                    type: 'weak'
                },
                reservedBgColor: 'rgba(0, 0, 0, 0)',
                finalType: 'default',
                realWidth: '',
            isAndroid: Env.isAndroid,
            lastClickTime: null
            }
        },
        computed: {
        },
        mounted() {
            let that = this;
            that.buttonDom   = that.$refs.button;
            that.progressDom = that.$refs.progress;
            that.progressTextDom = that.$refs.progress_text;
            if(this.width && this.width.indexOf('%') > -1) {
                if(that.buttonDom) {
                    let bound = that.buttonDom.getBoundingClientRect()
                    if(bound.width) {
                        this.realWidth = bound.width * parseInt(this.width) / 100 + 'px'
                    }
                }
            }
            // that.queryConfig()
            //     .then(function(res){
            //         if ( res.errcode == 0 ) {
            //             that.setConfig(res);
            //         } else {
            //             that.setConfig()
            //         }
            //         that.setStyle()
            //     }).catch(function(){
            //         that.setConfig()
            //         that.setStyle()
            //     })
            that.setStyle();
        },
        methods: {
            queryConfig: function() {
                let that = this;
                return new Promise(function(resolve, reject) {
                    reqButtonConfig(function(res) {
                        resolve(res)
                    }, function(err) {
                        reject(err)
                    })
                    // ajaxcall('https://game.weixin.qq.com/cgi-bin/gamecenterwap/getgamecenterbuttonconfig', {
                    //     method: 'POST',
                    // }, function(res) {
                    //     window.__normalButtonConfig = res;
                    //     resolve(res)
                    // }, function(err) {
                    //     reject(err);
                    // })
                })
            },
            setConfig: function(res = {data: {}}) {
                let that = this,
                  renderConfig = that.renderConfig;
                let pack = {
                    type: res.data.default_type,
                    main: res.data.main_color,
                    sub : res.data.sub_color,
                };
                for (let key in pack) {
                    if ( typeof pack[key] == 'object' ) {
                        for ( let dkey in pack[key] ) {
                            let newKey = dkey.replace(/_(\w)/g, function(a, b, c) {
                                return String.fromCharCode(b.charCodeAt(0) - 32);
                            })
                            renderConfig[key][newKey] = pack[key][dkey] || renderConfig[newKey];
                        }
                    } else if ( typeof pack[key] == 'string' ) {
                        renderConfig[key] = pack[key] || renderConfig[key];
                    }
                }
            },
            setStyle: function() {
                if( !this.buttonDom ) {
                    return
                }
                let that = this,
                  finalConfig = mergeDeep({}, copyObj(that.renderConfig), copyObj(that._props), this.styleObject);
                if ( finalConfig.type == 'default' ) {
                    finalConfig.type = that.renderConfig.type;
                } else {
                    finalConfig.type = finalConfig.type;
                }
                that.finalType = finalConfig.type;
                let active = this.active || finalConfig.active;
                let type = finalConfig.type;
                let fontSize = this.styleObject && this.styleObject.fontSize ? this.styleObject.fontSize + 'px' : finalConfig.font.fontSize
                let width = typeof finalConfig.width === 'number' ? (finalConfig.width + 'px') : finalConfig.width;
                let height = typeof finalConfig.height === 'number' ? (finalConfig.height + 'px') : finalConfig.height;
                that.buttonDom.style.fontSize = fontSize;
                that.buttonDom.style.fontFamily = finalConfig.font.fontFamily;
                // that.buttonDom.style.fontWeight = finalConfig.font.fontWeight;
                that.buttonDom.style.width = width;
                that.buttonDom.style.height = height;
                that.buttonDom.style.borderRadius = finalConfig.border.radius;
                that.buttonDom.style.lineHeight = parseFloat(finalConfig.height) + 'px';
                // 清理状态
                that.removeAllStyleClass(that.buttonDom)
                that.removeAllStyleClass(that.progressDom);
                if ( type == 'strong' ) {
                    that.buttonDom.classList.add('type_strong')

                    that.setProgress(0)
                } else if ( type == 'weak' ) {
                    that.buttonDom.classList.add('type_weak')
                    that.setProgress(0)
                } else if ( type == 'progress' ) {
                    that.buttonDom.classList.add('type_progress')
                    that.progressDom.classList.add('type_progress')
                    if(that.realWidth) {
                        that.progressTextDom.style.width = this.realWidth
                    }else {
                        that.progressTextDom.style.width = width;
                    }
                    that.setProgress(parseInt(that.text));
                } else if ( type == 'disable' || type == 'disabled' ) {
                    that.buttonDom.classList.add('type_disabled')
                    that.setProgress(0);
                }else if (type == 'warning') {
                    that.buttonDom.classList.add('type_warning')
                    that.setProgress(0);
                }else if (type == 'weaker') {
                    that.buttonDom.classList.add('type_weaker')
                    that.setProgress(0);
                }else if (type == 'white') {
                    that.buttonDom.classList.add('type_white')
                    that.setProgress(0);
                }
                if(that.main) {
                    that.main.bgColor && (that.buttonDom.style.backgroundColor = that.main.bgColor);
                }
                if(active) {
                    that.buttonDom.classList.add('button__wrapper-active')
                }
            },
            setProgress: function(progress) {
                this.progressDom && (this.progressDom.style.width = progress + '%');
            },
        buttonClicked: function (evt) {
            if (this.throttleTime && this.throttleTime > 0) {
                if (this.lastClickTime) {
                    let now = Date.now();
                    if (now >= this.lastClickTime + this.throttleTime) {
                        this.lastClickTime = now;
                        this.$emit('buttonClicked', evt);
                    }
                } else {
                    this.lastClickTime = Date.now();
                    this.$emit('buttonClicked', evt);
                }
            } else {
                this.$emit('buttonClicked', evt);
            }
            },
            removeAllStyleClass(el) {
                if(el) {
                    const classes = ['type_strong', 'type_weak', 'type_progress', 'type_disabled', 'type_warning', 'type_weaker', 'type_white', 'button__wrapper-active'];
                    classes.forEach(className => {
                        el.classList.remove(className);
                    })
                }
            }
        },
        watch: {
            type: function() {
                this.setStyle();
            },
            text: function() {
                if ( this.type == 'progress' ) {
                    this.setProgress(parseInt(this.text));
                }
            },
            styleObject: {
                handler () {
                    this.setStyle();
                },
                deep: true
            },
            main: {
                handler () {
                    this.setStyle();
                },
                deep: true
            },
            sub: {
                handler () {
                    this.setStyle();
                },
                deep: true
            },
        },
        components: {
            Icon
        }
    }
</script>
<style lang="less" scoped>
    @import './index.less';
</style>
